import React from 'react';

class EmailPopupModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailError: ''
    };
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  }

  handleEmailSubmit = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.state.email)) {
      this.setState({ emailError: 'Введите корректный email' });
      return;
    }
    this.props.onSubmit(this.state.email);
  }

  renderModalContent() {
    return (
      <div className="modal" style={{ display: 'block' }}>
        <div className="modal-content">
          <span className="close" onClick={this.props.onClose}>&times;</span>
          <div className="modal-body">
            <h3>Введите ваш email</h3>
            <input
              type="text"
              value={this.state.email}
              onChange={this.handleEmailChange}
              placeholder="Email"
            />
            {this.state.emailError && <div className="error">{this.state.emailError}</div>}
          </div>
          <div className="modal-footer">
            <button id="confirmButton" onClick={this.handleEmailSubmit}>Сохранить</button>
            <button onClick={this.props.onClose}>Отмена</button>
          </div>
          {this.props.children}
        </div>
        <style>
          {`
            .modal {
              display: none;
              position: fixed;
              z-index: 999999999;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              overflow: auto;
              background-color: rgba(0, 0, 0, 0.4);
              padding-top: 60px;
            }
            .modal-body {
              text-align: center;
            }
            .modal-footer {
              text-align: center;
              margin-top: 20px;
            }
            .modal-content {
              background-color: #fefefe;
              margin: 5% auto;
              padding: 20px;
              border: 1px solid #888;
              width: 80%;
              max-width: 450px;
            }
            .close {
              color: #aaa;
              position: absolute;
              top: 10px;
              right: 20px;
              font-size: 28px;
              font-weight: bold;
              cursor: pointer;
            }
            .close:hover,
            .close:focus {
              color: black;
              text-decoration: none;
              cursor: pointer;
            }
            input {
              display: block;
              margin: 0 auto;
              padding: 10px;
              font-size: 16px;
              height: 40px;
              width: 80%;
            }
            #confirmButton {
              background-color: #6d70d7;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 16px;
              margin-top: 20px;
            }
            #confirmButton:hover {
              background-color: #5c5f9e;
            }
          `}
        </style>
      </div>
    );
  }

  render() {
    if (!this.props.show) {
      return null; // Модалка не будет рендериться, если она не активна
    }

    // Используем портал для рендеринга модалки в body
    return ReactDOM.createPortal(
      this.renderModalContent(),
      document.body
    );
  }
}

export default EmailPopupModal;